import Exception from './exception';

export default Exception;
